import { Box, Link, Text } from '@chakra-ui/react';

import { RegistryPackage } from '@/graphql/upbound-graphql';
import { UPBOUND_LICENSES_URL } from '@/utils/constants/urls';

const PackageLegal: React.FC<{ data: RegistryPackage }> = ({ data }) => {
  if (!data.official) {
    return null;
  }

  return (
    <Box>
      <Text as="span" display="block" fontSize="14px" lineHeight="20px" color="black.0" fontWeight={900} mb="8px">
        Legal Notices
      </Text>
      <Link
        color="purple.0"
        _hover={{ textDecoration: 'underline' }}
        href={`${UPBOUND_LICENSES_URL}/notice-${data.name}.html`}
        target="_blank"
        rel="noopener noreferrer"
      >
        View
      </Link>
    </Box>
  );
};

export default PackageLegal;
